import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css'
import 'animate.css'
import '@/assets/css/base.scss'
import '@vant/touch-emulator'

import { Tab, Tabs, List, Collapse, CollapseItem, Dialog } from 'vant'

createApp(App)
  .use(store)
  .use(router)
  .use(Tab)
  .use(Tabs)
  .use(List)
  .use(Collapse)
  .use(CollapseItem)
  .use(Dialog)
  .mount('#app')
